
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function HireHero() {
  const { ref, isVisible } = useScrollAnimation();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-[90vh] flex items-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/f38ce8c71ce514d65f82864ad10b6852.jpg"
          alt="Premium Equipment Hire Melbourne"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      <div
        ref={ref}
        className={`relative z-10 w-full max-w-6xl mx-auto px-6 pt-32 pb-20 transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <div className="text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-amber-500/20 border border-amber-400/30 mb-6">
            <i className="ri-map-pin-line text-amber-300 text-sm"></i>
            <span className="text-amber-200 text-xs tracking-widest uppercase font-medium">
              Melbourne &amp; Surrounds
            </span>
          </div>

          <h1 className="font-display text-5xl md:text-7xl lg:text-8xl text-white mb-6 leading-tight">
            <a href="#portable-bars" className="hover:text-amber-200 transition-colors">
              <span className="block">Equipment</span>
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-200 via-yellow-100 to-amber-300">
                Hire Catalogue
              </span>
            </a>
          </h1>

          <p className="text-white/80 text-lg md:text-xl max-w-2xl mx-auto mb-10 font-light leading-relaxed">
            Premium <strong>portable bars</strong>, <strong>bar mats</strong> and accessories for hire across
            Melbourne. Elevate your next event with our curated collection.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={() => scrollToSection('portable-bars')}
              className="px-8 py-3.5 bg-gradient-to-r from-amber-400 via-amber-500 to-amber-600 text-stone-900 font-semibold rounded-full hover:from-amber-300 hover:via-amber-400 hover:to-amber-500 transition-all cursor-pointer whitespace-nowrap shadow-lg shadow-amber-500/30 text-sm"
            >
              <i className="ri-store-2-line mr-2"></i>Browse Catalogue
            </button>
            <button
              onClick={() => scrollToSection('booking-calendar')}
              className="px-8 py-3.5 bg-white/10 backdrop-blur-sm text-white font-semibold rounded-full border border-white/20 hover:bg-white/20 transition-all cursor-pointer whitespace-nowrap text-sm"
            >
              <i className="ri-calendar-check-line mr-2"></i>Check Availability
            </button>
          </div>

          <div className="flex items-center justify-center gap-8 mt-14">
            {[
              { icon: 'ri-truck-line', label: 'Free Delivery', sub: 'Melbourne Metro' },
              { icon: 'ri-tools-line', label: 'Setup Included', sub: 'Professional Team' },
              { icon: 'ri-shield-check-line', label: 'Fully Insured', sub: 'Peace of Mind' },
            ].map((item) => (
              <div key={item.label} className="text-center">
                <div className="w-12 h-12 rounded-full bg-amber-500/20 border border-amber-400/30 flex items-center justify-center mx-auto mb-2">
                  <i className={`${item.icon} text-amber-300 text-lg`}></i>
                </div>
                <p className="text-white text-xs font-medium">{item.label}</p>
                <p className="text-white/50 text-[10px]">{item.sub}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
